/**
 * RankingCard - Displays user's ranking
 */
export default function RankingCard({ rankGlobal, totalGlobal, rankMonth, totalMonth, rankingScore }) {
  if (!rankGlobal) return null;

  return (
    <div className="glass-card rounded-2xl p-4 sm:p-6 mb-4 sm:mb-6">
      <h3 className="font-outfit font-bold text-base sm:text-lg text-white mb-3 sm:mb-4">Ranking</h3>
      <div className="grid grid-cols-2 gap-3 sm:gap-4">
        <div className="bg-white/5 rounded-xl p-3 sm:p-4 text-center">
          <p className="text-xl sm:text-2xl font-outfit font-bold text-[#3B82F6]">#{rankGlobal}</p>
          <p className="text-[10px] sm:text-xs text-[#9CA3AF]">Global ({totalGlobal} Spieler)</p>
        </div>
        <div className="bg-white/5 rounded-xl p-3 sm:p-4 text-center">
          <p className="text-xl sm:text-2xl font-outfit font-bold text-[#8B5CF6]">#{rankMonth}</p>
          <p className="text-[10px] sm:text-xs text-[#9CA3AF]">Monat ({totalMonth} Spieler)</p>
        </div>
      </div>
      {rankingScore && (
        <p className="text-center text-xs sm:text-sm text-[#9CA3AF] mt-2 sm:mt-3">
          Ranking-Score: <span className="text-white font-mono font-bold">{rankingScore}</span>
        </p>
      )}
    </div>
  );
}
